import buildService, { NoParams } from 'common/utils/build-service'
import { GET } from 'common/requests'

export default buildService<NoParams, unknown, unknown, unknown>({
  type: GET,
  constantsPrefix: 'OFFLINE_TRAININGS',
  isArray: true,
  http: {
    createApiUrlSuffix: () => '/offline_trainings',
  },
})
